var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_17930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52161 18C9.45287 18.0002 9.38478 17.9869 9.3213 17.9607C9.25782 17.9345 9.20022 17.8961 9.15187 17.8475C9.05457 17.7497 9 17.6177 9 17.4802C9 17.3427 9.05457 17.2107 9.15187 17.1129L13.7003 12.594C13.8612 12.4341 13.9515 12.2172 13.9515 11.9911C13.9515 11.7649 13.8612 11.5481 13.7003 11.3881L9.15257 6.86995C9.06195 6.77117 9.01311 6.64151 9.01619 6.50789C9.01927 6.37428 9.07404 6.24697 9.16912 6.15242C9.2642 6.05787 9.39229 6.00334 9.52678 6.00015C9.66127 5.99696 9.79183 6.04536 9.89134 6.1353L14.4419 10.6534C14.6189 10.8289 14.7594 11.0374 14.8551 11.267C14.9509 11.4965 15.0001 11.7426 15 11.9911C15.0017 12.2398 14.9532 12.4863 14.8573 12.7161C14.7615 12.9458 14.6202 13.1541 14.4419 13.3287L9.89343 17.8475C9.79341 17.9433 9.66052 17.9978 9.52161 18Z",
    fill: "#003636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_17930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.df639c5dc59f74c94ef54be947386c94.svg";
export { ForwardRef as ReactComponent };